import { Injectable } from "@angular/core";
import { DataService } from "./core/services/data.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class NavigationService {
  list: any[] = [];
  currentIndex = 0;

  constructor(private dataService: DataService, private router: Router) {}

  setList(list: any[]) {
    this.list = list;
  }

  setCurrentIndex(index: number) {
    this.currentIndex = index;
    console.log(this.currentIndex, "this.currentIndex");
  }

  getCurrentItemPersonal() {
    return this.list[this.currentIndex];
  }

  next(type): any | null {
    if (type == "personal") {
      if (this.currentIndex < this.list.length - 1) {
        this.currentIndex++;
        this.router.navigate([
          "/teamium/personal/staff-details",
          this.getCurrentItemPersonal().id,
        ]);
      }
    }

    if (type == "equipment") {
      if (this.currentIndex < this.list.length - 1) {
        this.currentIndex++;
        this.router.navigate([
          "/teamium/equipment/equipment-details",
          this.getCurrentItemPersonal().id,
        ]);
      }
    }

    if (type == "project") {
      if (this.currentIndex < this.list.length - 1) {
        this.currentIndex++;
        let project = this.getCurrentItemPersonal();
        let pathVariable: any = new Array();
        if (project.isBooked == true || project.booked) {
          pathVariable.push({ projectId: project.id });
          this.router.navigate([
            "/teamium/project/project-booking/" + project.id,
          ]);
        } else {
          this.router.navigate([
            "/teamium/project/project-budgeting/" + project.id,
          ]);
          pathVariable.push({ projectId: project.id });
        }
      }
    }

    // return null;
  }

  prev(type): any | null {
    if (type == "personal") {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.router.navigate([
          "/teamium/personal/staff-details",
          this.getCurrentItemPersonal().id,
        ]);
      }
    }

    if (type == "equipment") {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.router.navigate([
          "/teamium/equipment/equipment-details",
          this.getCurrentItemPersonal().id,
        ]);
      }
    }

        if (type == "project") {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        let project = this.getCurrentItemPersonal();
        let pathVariable: any = new Array();
        if (project.isBooked == true || project.booked) {
          pathVariable.push({ projectId: project.id });
          this.router.navigate([
            "/teamium/project/project-booking/" + project.id,
          ]);
        } else {
          this.router.navigate([
            "/teamium/project/project-budgeting/" + project.id,
          ]);
          pathVariable.push({ projectId: project.id });
        }
      }
    }
  }

  hasNext(): boolean {
    return this.currentIndex < this.list.length - 1;
  }

  hasPrev(): boolean {
    return this.currentIndex > 0;
  }
}
